var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"answers"},[_c('ul',_vm._l((_vm.allAnswers),function(a,index){return _c('answer',{key:_vm.answerIndex(),attrs:{"index":index,"answer-text":a.answer,"is-correct":a.correct,"identifier":a.id}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }